import React from "react";
import WavyDivider from "./WavyDivider";
import { siteData } from "../mock";

const Tarifs = () => {
  const { cabinet, entreprise, remboursement } = siteData.tarifs;
  return (
    <section id="tarifs" className="section tarifs">
      <div className="section-header">
        <WavyDivider />
        <h2 className="section-title">Tarifs</h2>
        <h3 className="section-subtitle">
          Particuliers — Entreprises — Événements Bien-Être.
        </h3>
      </div>

      <div className="tarifs-grid">
        <div className="tarif-card">
          <div className="tarif-eyebrow">En cabinet — La Ciotat</div>
          <h4 className="tarif-heading">Particuliers</h4>
          <ul className="tarif-list">
            {cabinet.map((t) => (
              <li key={t.label}>
                <span>{t.label}</span>
                <span className="tarif-price">{t.price}</span>
              </li>
            ))}
          </ul>
          <p className="tarif-note">{remboursement}</p>
        </div>

        <div className="tarif-card">
          <div className="tarif-eyebrow">En entreprise — QVCT</div>
          <h4 className="tarif-heading">Entreprises &amp; collectivités</h4>
          <h2 className="tarif-sub">Offre personnalisée dans le cadre de la politique RSE et de la QVCT</h2>
          <ul className="tarif-list">
            {entreprise.map((t) => (
              <li key={t.label}>
                <span>{t.label}</span>
                <span className="tarif-price">{t.price}</span>
              </li>
            ))}
          </ul>
          <p className="tarif-note">
            Séances courtes de 20 min proposées sur le temps de travail, avec un intervalle de 10 min entre chaque soin. J’interviens à La Ciotat, Aubagne, Aix, Marseille et Toulon et apporte mon matériel (chaise de massage).
          </p>
        </div>
      </div>
    </section>
  );
};

export default Tarifs;
